<template>
  <div class="auditDetails">
    <head-panel title="财务管理" subtitle="FINANCIAL MANAGEMENT" :exportExc="false"></head-panel>
    <div class="formPanel">
      <h3 class="subTit">{{currentTitle}}</h3>
      <el-form :model="form" ref="form" class="ruleForm" :rules="rules" label-width="12%">
        <h4 class="form-title">广告主/代理商信息</h4>
        <el-form-item label="广告主/代理商名称">
          <el-input v-model="form.adverName" class="input_sm" disabled></el-input>
        </el-form-item>
        <el-form-item label="类型">
          <el-input v-model="form.type" class="input_sm" disabled></el-input>
        </el-form-item>
        <el-form-item label="代理商/广告主id">
          <el-input v-model="form.accountId" class="input_sm" disabled></el-input>
        </el-form-item>
        <el-form-item label="平台账户名称">
          <el-input v-model="form.accountName" class="input_sm" disabled></el-input>
        </el-form-item>
        <el-form-item label="对公银行名称">
          <el-input v-model="form.bankName" class="input_sm" disabled></el-input>
        </el-form-item>
        <el-form-item label="对公银行账号">
          <el-input v-model="form.bankNum" class="input_sm" disabled></el-input>
        </el-form-item>
        <el-form-item label="对公开户支行">
          <el-input v-model="form.bankSub" class="input_lg" disabled></el-input>
        </el-form-item>
        <h4 class="form-title">财务编辑信息</h4>
        <el-form-item label="操作人用户名称" required>
          <el-input v-model="form.userName" class="input_sm" disabled></el-input>
        </el-form-item>
        <el-form-item label="操作人员邮箱" required>
          <el-input v-model="form.emails" class="input_lg" disabled></el-input>
        </el-form-item>
        <el-form-item label="上传到款凭证" required>
          <div class="upload-img" v-if="imgUrl" @click="handleImgShow">
            <img :src="imgUrl" alt />
          </div>
        </el-form-item>
        <el-form-item label="金额类型">
          <!--<el-input v-model="form.bankName" class="input_sm" disabled></el-input>-->
          <ny-select
            :data="cashTypeMenu"
            v-model="form.cashType"
            :keyValue="['value', 'name']"
            @change="changeSelect"
            type="bankName"
            placeholder="请选择"
            class="advertiseSelect input_sm"
            disabled
          ></ny-select>
        </el-form-item>
        <el-form-item label="录入到款金额" prop="money">
          <div class="amountMoney" ref="amountMoney">
            <el-input v-model="form.money" class="input_sm inputTooltip" disabled>
              <template slot="append">元</template>
            </el-input>
            <div ref="amountLeft" class="amountLeft" v-if="form.moneyToolTip !== ''">
              <span>{{form.money}}</span>
              <div class="el-tooltip__popper is-dark amountTooltip" ref="amountTooltip">
                {{form.moneyToolTip}}
                <div
                  x-arrow
                  class="popper__arrow"
                  style="    border-top-width: 0;
    border-bottom-color: #1f2d3d; top:-6px;"
                ></div>
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="审核" class="L8">
          <el-radio-group v-model="form.status" :disabled="isShow" v-if="!isShow">
            <el-radio
              v-for="item in financial.auditStatusMenu"
              :key="item.value"
              :value="item.value"
              :label="item.value"
            >{{item.name}}</el-radio>
          </el-radio-group>
          <label v-else-if="form.status === '0'">待审核</label>
          <label v-else-if="form.status === '1'">已通过</label>
          <label v-else-if="form.status === '2'">已拒绝</label>
        </el-form-item>
        <el-form-item label="拒绝原因" prop="reason" v-if="form.status === '2'" :disabled="isShow">
          <el-input
            type="textarea"
            v-model="form.reason"
            class="input_sm"
            resize="none"
            :autosize="{ minRows: 2 }"
          ></el-input>
        </el-form-item>
        <el-form-item class="btnGroups">
          <el-button type="primary" v-if="!isShow" class="commit" @click="submitForm('form')">提交</el-button>
          <el-button type="primary" class="is-cancel" size="large" @click="cancel('form')">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
    <custom-dialog :customDialog="imageDialog" class="imgShow">
      <div slot="dialogCon">
        <img :src="imgUrl" alt />
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import { headPanel, customDialog, NySelect } from '@/global/components';
import { post } from '../../http/index'
import { mapGetters } from 'vuex';
import { amountUnit, comdify } from '@/global/util/util'
export default {
  data () {
    return {
      currentTitle: '审核',
      isShow: false,
      imgUrl: '',
      imageDialog: {
        visible: false,
        isShowClose: true,
        isPressEscape: true
      },
      cashTypeMenu: [],
      form: {
        adverName: '',
        type: '',
        bankName: '',
        bankNum: '',
        bankSub: '',
        userName: '',
        emails: '',
        money: '',
        status: '1',
        reason: '',
        cashType: '',
        accountName: '',
        accountId: '',
        moneyToolTip: '',
        updateAt: ''
      },
      rules: {
        money: [
          { required: true, message: '请输入金额' },
          { type: 'string', message: '金额必须是数字' }
        ],
        reason: [
          { required: true, message: '请输入拒绝原因', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapGetters({
      financial: 'finance/financial',
      userid: 'login/userid'
    })
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.currentTitle = this.$route.name === 'auditDetails' ? '审核' : '查看'
      this.isShow = this.$route.name === 'showAuditDetails'
      this.$store.dispatch('finance/getAuditStatusMenu')
      this.$store.dispatch('finance/getPriceTypeMenu', { type: 'rebate_type' }).then(res => {
        if (res.code === 1) {
          this.cashTypeMenu = res.data
        }
      })
      this.getAuditInfo()
    },
    getAuditInfo () {
      post('/admin/finance/info', { id: this.$route.params.id }).then(res => {
        if (res.code === 1) {
          let data = res.data
          this.form.adverName = data.top.username
          this.form.type = data.top.user_type
          this.form.accountName = data.top.account_name
          this.form.bankName = data.top.bank
          this.form.bankNum = data.top.account
          this.form.bankSub = data.top.bank_addr
          this.form.cashType = data.examine.type + ''
          this.form.userName = data.examine.operation_name
          this.form.emails = data.examine.operation_email
          this.form.money = comdify(data.examine.money)
          this.form.moneyToolTip = amountUnit(data.examine.money)
          this.form.accountId = data.examine.user_id
          this.form.status = data.examine.status + ''
          this.form.updatedAt = data.examine.updated_at
          this.form.reason = data.examine.refuse
          this.imgUrl = data.examine.img_host + data.examine.img_path
        }
      })
    },
    handleImgShow () {
      this.imageDialog.visible = true
    },
    changeSelect () { },
    submitForm (formName) {
      let self = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {}
          params.id = self.$route.params.id
          params.status = self.form.status
          params.refuse = self.form.reason
          params.updated_at = self.form.updatedAt
          post('/admin/finance/status', params).then(res => {
            if (res.code === 1) {
              self.$message('修改状态成功')
              setTimeout(() => {
                self.$router.push({ name: 'auditFinancial' });
              }, 100)
            } else {
              self.$message(res.msg)
              if (res.code === 301) {
                self.$router.push({ name: 'auditFinancial' });
              }
            }
          })
        }
      });
    },
    cancel (formName) {
      this.$refs[formName].resetFields();
      this.$router.push({ name: 'auditFinancial' });
    }
  },
  components: {
    headPanel,
    customDialog,
    NySelect
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" type="text/scss">
.auditDetails {
  .ruleForm {
    .input_sm {
      width: 210px;
    }
    .input_lg {
      width: 350px;
    }
    .ml16 {
      margin-left: 16px;
    }
    .mr20 {
      margin-right: 20px;
    }
    .el-form-item {
      margin-bottom: 22px;
    }
    .btnGroups {
      text-align: left;
      margin-left: 16px;
    }
  }
  .upload-img {
    width: 200px;
    height: 200px;
    cursor: pointer;
    display: inline-block;
    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }
  .form-title {
    margin-left: 20px;
    font-size: 18px;
    margin-bottom: 10px;
  }
  .imgShow {
    text-align: center;
    img {
      max-width: 100%;
      height: auto;
    }
    .el-dialog--small {
      width: 50%;
    }
  }
  .moneyTooltip {
    position: absolute;
  }
  .amountMoney {
    width: 175px;
    margin-left: 16px;
    box-sizing: border-box;
    text-align: center;
    position: absolute;
    height: 28px;
    span {
      opacity: 0;
      font-size: inherit;
    }
    &:hover {
      .amountTooltip {
        display: block;
      }
    }
  }
  .amountLeft {
    display: inline-block;
    position: relative;
    top: -28px;
  }
  .amountTooltip {
    left: -10px;
    top: 38px;
    display: none;
  }
}
</style>
